// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610211643/js/" + chunkId + "." + {"44":"85f544f6","225":"a34d6c5d","481":"cbf636c5","486":"d779db4d","770":"6315e138"}[chunkId] + ".0.7290270108942896.chunk.js";
};